import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCertificationListAPI, getSingleCertificateAPI } from "../../apiConfig/apiCall";

export const getCertificationList = createAsyncThunk('getComplianceList', async () => {
    const response = await getCertificationListAPI();
    return response.data;
});

export const getSingleCertificate = createAsyncThunk('getSingleCertificate', async (ID) => {
    const response = await getSingleCertificateAPI(ID);
    return response.data;
});

const manageComplianceSlice = createSlice({
    name: "manageCompliance",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
        certificateDetails: {}
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCertificationList.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(getCertificationList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getCertificationList.rejected, (state) => {
                state.isError = true;
                state.isLoading = false;
            })

            .addCase(getSingleCertificate.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(getSingleCertificate.fulfilled, (state, action) => {
                state.isLoading = false;
                state.certificateDetails = action.payload;
            })
            .addCase(getSingleCertificate.rejected, (state) => {
                state.isError = true;
                state.isLoading = false;
            })
    }
});

export default manageComplianceSlice.reducer;